import { render, staticRenderFns } from "./upPost.vue?vue&type=template&id=4ac819af&scoped=true&"
import script from "./upPost.vue?vue&type=script&lang=js&"
export * from "./upPost.vue?vue&type=script&lang=js&"
import style0 from "./upPost.vue?vue&type=style&index=0&lang=less&"
import style1 from "./upPost.vue?vue&type=style&index=1&id=4ac819af&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac819af",
  null
  
)

export default component.exports